<!-- Modal Header -->
<div class="modal-header">
  <h1 class="modal-title">{{ 'add_icon_title' | label : 'homepagesettings' | async }}</h1>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <div class="alert alert-info mb-4" *ngIf="widgetsettings">
    <span style="text-decoration: underline">{{ 'explanation_icon_select' | label : 'homepagesettings' | async }}</span
    >:
    <br />
    {{ 'explanation_icon_select_1' | label : 'homepagesettings' | async }}
    <br />
    {{ 'explanation_icon_select_2' | label : 'homepagesettings' | async }}
    <br />
    <br />
    {{ 'explanation_icon_select_3' | label : 'homepagesettings' | async }}
    <br />
    {{ 'explanation_icon_select_4' | label : 'homepagesettings' | async }}
    <br />
    {{ 'explanation_icon_select_5a' | label : 'homepagesettings' | async }} <a class="primary-link-color" href="/perfnav/administration/en/adm/V2contents.asp?redirectchild=%2Fframework%2Fsettings%2Fcompany-styling%3FmenuItem%3D564" target="_blank">{{ 'explanation_icon_select_5b' | label : 'homepagesettings' | async }}</a
    >.
    <br />
    <br />
    {{ 'explanation_icon_select_6' | label : 'homepagesettings' | async }}
    <br />
    {{ 'explanation_icon_select_7' | label : 'homepagesettings' | async }}
    <br />
    <ul class="ul--disc">
      <li>{{ 'explanation_icon_select_8' | label : 'homepagesettings' | async }}</li>
      <li>{{ 'explanation_icon_select_9' | label : 'homepagesettings' | async }}</li>
      <li>{{ 'explanation_icon_select_10' | label : 'homepagesettings' | async }}</li>
      <li>{{ 'explanation_icon_select_11' | label : 'homepagesettings' | async }}</li>
    </ul>
    <br />
    {{ 'explanation_icon_select_12' | label : 'homepagesettings' | async }}
    <br />
    {{ 'explanation_icon_select_13' | label : 'homepagesettings' | async }}
  </div>

  <!-- Search Bar for searching an icon -->
  <div class="row mb-4">
    <div class="col-6">
      <div class="row">
        <div class="col-12">
          <label for="search" class="form-label">{{ 'search_icon_library' | label : 'homepagesettings' | async }}</label
          >:
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <input type="search" id="search" class="form-control" style="margin-right: 15px" placeholder="{{ 'search' | label : 'learningpath' | async }}" (keydown)="iterator()" (keyup)="iterator()" (change)="iterator()" (search)="iterator()" (blur)="iterator()" [(ngModel)]="iconSearchName" />
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="row">
        <div class="col-12">
          <label for="iconUpload" class="form-label">{{ 'add_your_own_icon' | label : 'homepagesettings' | async }}</label
          >:
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <input type="file" id="iconUpload" class="form-control" (change)="onFileSelected($event)" accept=".png, .svg" />
        </div>
      </div>
      <div *ngIf="uploadError" class="text-danger mt-2">{{ uploadError }}</div>

      <div *ngIf="uploadedImage" class="mt-3">
        <p>{{ 'example' | label : 'cvtemplates' | async }}:</p>
        <div class="icon-box uploaded-icon selected">
          <div class="icon-svg" *ngIf="isSvgFormat" [innerHTML]="uploadedImage | safeHTML"></div>
          <img *ngIf="!isSvgFormat" [src]="uploadedImage" class="icon-svg" style="max-width: 100px; max-height: 100px" />
        </div>
      </div>
    </div>
  </div>
  <!-- Show all icons -->
  <div class="d-flex flex-wrap gap-3">
    <div *ngFor="let icon of filteredIcons" class="icon-box" (click)="selectIcon(icon)" [class.selected]="selectedIcon === icon">
      <div [innerHTML]="icon.svgSafe" class="icon-svg" [title]="icon.nameEN"></div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="row flex-grow-1">
    <div class="col-12 text-end">
      <button type="button" (click)="close()" class="btn btn-cancel">
        {{ 'cancel' | label : 'general' | async }}
      </button>
      <button type="button" (click)="saveSelection(selectedIcon)" class="btn btn-progreso">
        {{ 'save' | label : 'general' | async }}
      </button>
    </div>
  </div>
</div>
